import { Outlet } from "@tanstack/react-router";
import { Navigate } from "./Navigate";
import useAuthorisation from "../hooks/useAuthorisation";
import { Loading } from "../components/Loading";

export const RouteAuthorisation = ({ allowedRoles }) => {
  const { authorisation } = useAuthorisation();

  const getTrueKeys = (obj) =>
    Object.keys(obj).filter((key) => obj[key] === true);

  const userRoles = getTrueKeys(authorisation?.roles);

  return authorisation.loading ? (
    <Loading />
  ) : userRoles.find((role) => allowedRoles?.includes(role)) ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorised" replace />
  );
};
